<p-floatLabel>
  <p-select #periodStateDropdown
            id="periodStateDropdown"
            name="periodStateDropdown"
            [options]="periodStates"
            [(ngModel)]="periodState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="periodStateDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
